import {BackgroundImageSchema} from './backgroundImage'
import {PrimerComponentCtaBannerSchema} from './primerComponentCtaBanner'
import {PrimerComponentFaqGroupSchema} from './primerComponentFaqGroup'
import {PrimerComponentHeroSchema} from './primerComponentHero'
import {PrimerComponentSubnavSchema} from './primerComponentSubnav'
import {PrimerComponentTestimonialSchema} from './primerComponentTestimonial'
import {FlexSectionSchema} from './flexSection'
import {buildEntrySchemaFor} from '../entry'
import {z} from 'zod'
import {buildPageSchemaForTemplate} from './containerPage'

export const TemplateFlexSchema = buildEntrySchemaFor('templateFlex', {
  fields: z.object({
    subnav: PrimerComponentSubnavSchema.optional(),
    hero: PrimerComponentHeroSchema,
    heroBackgroundImage: BackgroundImageSchema.optional(),
    sections: z.array(FlexSectionSchema),
    testimonials: z.array(PrimerComponentTestimonialSchema).optional(),
    ctaBanner: PrimerComponentCtaBannerSchema.optional(),
    faq: PrimerComponentFaqGroupSchema.optional(),
    trailingSectionRoundedCorners: z.boolean().optional(),
    trailingSectionBackgroundColor: z.enum(['default', 'subtle']).optional(),
  }),
})

export const FlexPageSchema = buildPageSchemaForTemplate(TemplateFlexSchema)
export type FlexPage = z.infer<typeof FlexPageSchema>
